import SettingsIcon from '../assets/icons/settings'
import TouchableOpacity from '../common/TouchableOpacity'
import { useState, Dispatch, SetStateAction, RefObject } from 'react'
import type { DrawerHandle } from '../features/drawer'
import StreamPicker from './StreamPicker'
import ShareScreenButton from './ShareScreenButton'
import styles from './style'

type HeaderBarProps =
  | {
      isAdmin: true
      drawerRef: RefObject<DrawerHandle | null>
      isDrawerOpen: boolean
      setDrawerOpen: Dispatch<SetStateAction<boolean>>
    }
  | {
      isAdmin: false
    }

function HeaderBar(props: HeaderBarProps) {
  const [rotated, setRotated] = useState(false)

  return (
    <div style={styles.bar}>
      <div style={styles.row}>
        <ShareScreenButton />
        {props.isAdmin ? (
          <TouchableOpacity
            style={{
              ...styles.toggleButton,
              transform: rotated ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
            onClick={() => {
              setRotated(!rotated)
              if (props.drawerRef.current?.handleDrawerState) {
                props.drawerRef.current.handleDrawerState(!props.isDrawerOpen ? 'open' : 'closed')
              }
              props.setDrawerOpen(!props.isDrawerOpen)
            }}
          >
            <SettingsIcon size={42} />
          </TouchableOpacity>
        ) : (
          <StreamPicker />
        )}
      </div>
    </div>
  )
}

export default HeaderBar
